import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";

import wordicon from "../../assets/ms_word.png";
import excelicon from "../../assets/ms_excel.png";
import pdficon from "../../assets/pdf.png";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";
import PdfViewer from "../../components/controls/pdfviewer";
import JisDialogForm from "../../components/formdialog";
import JisTabButton from "../../components/controls/jisTabButton";

function FeePaymentReport() {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const [fees, setFees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [count, setCount] = useState(0);
  const [tab, setTab] = useState("paid");
  const [fetchingReceipt, setFetchingReceipt] = useState({});
  const [previewUrl, setPreviewUrl] = useState("");
  const [summary, setSummary] = useState(null);

   useEffect(() => {
    if (search != null) {
      if (pageIndex >= 0) {
        onSearch(search);
      } else {
        setPageIndex(0);
      }
    }
  }, [pageIndex, pageSize, search,tab]);

  const onSearch = async (sear) => {
    const url=tab=='paid'?`${Constants.apiUrl}/report/payment-report/${tab}/${pageIndex}/${pageSize}`:`${Constants.apiUrl}/report/payment-report-summary`;
    setLoading(true);
    try {
      const resp = await fetch(
        url,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        if(tab=='paid'){
          setFees(data.items);
          if (pageIndex == 0) {
            setCount(data.totalCount);
          }
        }else{
          setSummary(data.summary)
        }
       
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

 
  const onContinue = (caseid) => {
    navigate(`/case-details/${caseid}`);
  };
  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onDirectSearch = (sear) => {
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };
  const onRevenueReceipt = (pay) => {
    setPreviewUrl(pay?.receiptUrl);
    setIsPreview(true);
  };

  // Add this function after the onDirectSearch function and before the return statement

  // Add this function after the onDirectSearch function and before the return statement

  const onExport = async (doctype) => {
    // Map doctype to MIME and extension
    const typeMap = {
      word: {
        mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ext: "docx",
      },
      excel: {
        mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ext: "xlsx",
      },
      pdf: {
        mime: "application/pdf",
        ext: "pdf",
      },
    };

    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/report/payment-report/${doctype}`,
        {
          method: "POST",
          body: JSON.stringify(search),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!resp.ok) {
        const data = await resp.json();
        if (data.code === -10) {
          setIsExpired(true);
        } else {
          setErr(data.status || "Export failed");
        }
        setLoading(false);
        return;
      }

      const blob = await resp.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `my-cases.${typeMap[doctype].ext}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl); // Clean up URL

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr("Export failed");
    }
  };
   const handleJudiciaryReceipt = (paymentId) => {
      setPreviewUrl(`${Constants.baseurl}/receipt/${paymentId}`);
      setIsPreview(true);
    };
  return (
    <div>
      
      <CustomSearchSortHeader
        onSearch={onDirectSearch}
        frequentData={frequentData}
      />

<div className="tab_body">
 {fees?.length == 0 && <JisEmptyList />}
      {fees?.length > 0 && (
        <>
         
          <div className="tab_section cfo-tab-wrapper">
            <JisTabButton
              isActive={tab == "paid"}
              title="Transaction Details"
              isRoleBased={false}
              onClick={() => setTab("paid")}
            />
            <JisTabButton
              isActive={tab == "summary"}
              title="Transaction Summary"
              isRoleBased={false}
              onClick={() => setTab("summary")}
            />
           
          </div>
       {tab=='paid' && <div  className="tab_view">
           <div className="exportdiv">
            <img
              src={wordicon}
              onClick={() => onExport("word")}
              style={{ cursor: "pointer" }}
            />
            <img
              src={excelicon}
              onClick={() => onExport("excel")}
              style={{ cursor: "pointer" }}
            />
            <img
              src={pdficon}
              onClick={() => onExport("pdf")}
              style={{ cursor: "pointer" }}
            />
          </div>
            <div className="table">
                <div class="section-cases">
                <span>Payment </span>
                </div>
                <div className="table-wrapper">
                <table class="case-table">
                    <thead>
                    <tr>
                        <th className="col-title">Suit Number</th>
                        <th className="col-title">Case Title</th>
                        <th className="col-medium">Reference Number</th>
                        <th className="col-medium">External</th>
                        <th className="col-medium">Internal</th>
                        <th className="col-medium">Transaction Id</th>
                        <th className="col-medium">Source</th>
                        <th className="col-medium">Date</th>
                       
                        <th className="col-title">Receipts</th>
                    </tr>
                    </thead>
                    <tbody>
                    {fees?.map((opt, index) => (
                        <tr key={index}>
                        <td style={{ backgroundColor: `${ Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.colour}`, }} >
                            {opt.caseNumber ?? opt.referenceNumber}
                        </td>
                        <td>{opt.caseTitle || "N/A"}</td>
                        <td> {opt.webGuid || "N/A"} </td>
                        <td>
                            {opt.externalFee || "N/A"}
                        </td>
                        <td>
                            {opt.internalFee || "N/A"}
                        </td>
                        <td>{ opt.gatewayTransId}{opt.paymentType!='Debit' && opt.paymentType}</td>
                        <td>{opt.gateway?.name}</td>
                        <td>
                            {Constants.momentDate(opt.createdOn).format( "DD MMM, YYYY" ) || "N/A"}
                        </td>
                       
                        <td>
                       <>
                       {!(opt.receiptUrl==null || opt.receiptUrl=='') && <JisButton variant="plain" onClick={() => onRevenueReceipt(opt)}>
                            Revenue
                            </JisButton>}  {opt.gatewayTransId!=null  && <JisButton variant="plain" onClick={() => handleJudiciaryReceipt(opt.id)}>
                            Judiciary
                            </JisButton>}
                       </> 
                        </td>

                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
                {fees?.length > 0 && (
                <Pagenated
                    onChangePageSize={(k) => setPageSize(k)}
                    size={pageSize}
                    total={count}
                    maxPage={20}
                    onPick={onPagePick}
                />
                )}
            </div>
          </div>}  
        {tab=='summary' && <div className="tab_view">
          <div className="dashboard">
             <div className="main-row">
              <div  className="left-cards">
                <div className="card">
                  <div className="card-icon">
                    <DynamicIcon iname="square-check" size={24} color={"white"} />
                  </div>
                  <div>External Payments</div>
                  <div className="card-value">N {Constants.formatCurrency(summary?.totalExternalFee)}</div>
                </div>

                <div className="card">
                  <div className="card-icon">
                    <DynamicIcon iname="square-check" size={24} color={"white"} />
                  </div>
                  <div>Internal Payments</div>
                  <div className="card-value">N {Constants.formatCurrency(summary?.totalInternalFee)}</div>
                </div>

                <div className="card">
                  <div className="card-icon">
                    <DynamicIcon iname="square-check" size={24} color={"white"} />
                  </div>
                  <div>Grand Total</div>
                  <div className="card-value">N {Constants.formatCurrency(summary?.totalFee) }</div>
                </div>

                <div className="card">
                  <div className="card-icon">
                    <DynamicIcon iname="tally-4" size={24} color={"white"} />
                  </div>
                  <div>Numbers of Transactions</div>
                  <div className="card-value">{Constants.formatCurrency(summary?.recordCount)}</div>
                </div>

              </div>
            </div>
          </div>
           
          </div>}   
         
        </>
      )}
</div>
     
      <BackLoader open={loading} />
       {isPreview && (
              <JisDialogForm title="Preview" onClose={() => setIsPreview(false)}>
                <div>
                  <div style={{ height: "90vh" }}>
                    <PdfViewer pdfUrl={previewUrl} />
                  </div>
                </div>
              </JisDialogForm>
            )}
    </div>
  );
}

export default FeePaymentReport;
